<template>
<div class="chapter">
<div class="inner_page">
<h2 class="label"><a id="page_13"></a><a id="pt1"></a>1</h2>
<h2 class="h2a"><em>Martianus Capella, Remigius of Auxerre, William of Malmesbury</em><a id="page_14"></a></h2>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9780226724607_07_pt1.vue?855c3cfc